import { render, staticRenderFns } from "./EnrollError.vue?vue&type=template&id=ca4ca1aa&scoped=true"
import script from "./EnrollError.vue?vue&type=script&lang=js"
export * from "./EnrollError.vue?vue&type=script&lang=js"
import style0 from "./EnrollError.vue?vue&type=style&index=0&id=ca4ca1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4ca1aa",
  null
  
)

export default component.exports